import auth from "../middlewares/auth";
export const news = [
    {
        path: '/news',
        component: () => import(/* webpackChunkName: "news" */ '../views/news/Index'),
        name: 'news',
        meta: {
            middleware: [
                auth
            ]
        }
    },
    {
        path: '/news/add',
        component: () => import(/* webpackChunkName: "news" */ '../views/news/Form'),
        name: 'news_add',
        meta: {
            middleware: [
                auth
            ]
        }
    },
    {
        path: '/news/edit/:id',
        component: () => import(/* webpackChunkName: "news" */ '../views/news/Form'),
        name: 'news_edit',
        meta: {
            middleware: [
                auth
            ]
        }
    },
];
